/* eslint-disable no-dupe-class-members */
import Vue from 'vue';
import { Instance, instanceSettings } from '@ekd/portal-connector/dist/Instance';
import { InstanceContext, Instances } from '@root/common/types/instanceConnector';
import listenToCustomerLoginState from '@customer/utils/listenToCustomerLoginState';

import { loginApiClient } from '../utils/loginApiClient';

@instanceSettings({ name: 'customer' })
export class CustomerInstance extends Instance<InstanceContext, Instances> {
  public state = Vue.observable({
    profile: null,
    token: '',
    isLoggedIn: false,
    isInited: false,
    locale: 'lt',
  });

  public listen(listenTo: 'isInited', cb: (isInited: boolean) => void): void;
  public listen(listenTo: 'token', cb: (token: string) => void): void;
  public listen(listenTo: string, cb: (token: any) => void) {
    this.context.$eventHandler.on(listenTo, cb);
  }

  public async init({ locale }: { locale: string }) {
    const isServer = typeof window === 'undefined';

    if (isServer) {
      return;
    }

    const clientInstance = this.context.store?.$config?.CHANNEL_CONFIG_ENV;
    const clientToken = await (await loginApiClient(clientInstance)).getToken();
    this.state.isLoggedIn = !!clientToken;
    this.state.isInited = true;
    this.context.store.state.customer.locale = locale;
    this.context.$eventHandler.emit('isInited', true);
  }

  public listenToCustomerLoginState() {
    const isServer = typeof window === 'undefined';

    if (isServer) {
      return;
    }

    this.context.store.watch(
      (state: { customer: { token: string } }) => state.customer.token,
      async (token: string | null) => {
        this.state.token = token || '';
        this.state.isLoggedIn = !!token;
        this.state.profile = this.context.store.state.customer.profile;

        this.context.$eventHandler.emit('token', this.state.token);
      }
    );

    listenToCustomerLoginState(this.context.store);
  }
}
